import { Button, Modal } from '@examflow/ui';
import type { ActiveSession } from '../../data/local';

interface SessionRestoreProps {
  session: ActiveSession;
  onContinue: () => void;
  onDiscard: () => void;
}

export function SessionRestore({ session, onContinue, onDiscard }: SessionRestoreProps) {
  const isPractice = session.mode === 'practice';
  const scopeLabel = session.platformScope
    ? `${session.platformScope.languageName} · ${session.platformScope.examName}`
    : session.examType.toUpperCase();
  const answeredCount = session.userAnswers.filter(
    (answer) => String(answer.answer ?? '').trim().length > 0
  ).length;
  const title = isPractice ? '检测到未完成的训练' : '检测到未完成的模考';
  const body = isPractice
    ? `共 ${session.questionIds.length} 题，已答 ${answeredCount} 题。继续本轮会恢复本地进度；开新一轮会丢弃本轮未交卷作答。`
    : `共 ${session.questionIds.length} 题，已答 ${answeredCount} 题。继续模考会恢复本地进度；放弃并重新开始会清空本轮未交卷作答。`;
  const continueLabel = isPractice ? '继续本轮' : '继续模考';
  const discardLabel = isPractice ? '开新一轮' : '放弃并重新开始';

  return (
    <Modal
      isOpen
      // Must pick explicitly — backdrop / Esc must not wipe or resume by accident.
      onClose={() => undefined}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onDiscard}>
            {discardLabel}
          </Button>
          <Button onClick={onContinue}>{continueLabel}</Button>
        </>
      }
    >
      <h2 className="mb-2 text-lg font-semibold text-slate-900">{title}</h2>
      <div className="mb-2 text-sm font-semibold text-primary-700">{scopeLabel}</div>
      <p className="text-sm leading-6 text-slate-600">{body}</p>
    </Modal>
  );
}
